export function handleDropImagesAdapter({ id, getValues, setValue }) {
  return function (files) {
    const images = getValues(id);
    setValue(id, [
      ...images,
      ...files.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      ),
    ]);
  };
}

export function handleDropImageAdapter({ id, setValue }) {
  return function (files) {
    const file = files[0];

    if (file) {
      setValue(
        id,
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
    }
  };
}
